export default __webpack_public_path__ + "static/media/home-interior-design-services-04.ba539075.jpg";